"use strict";
import {isBoolean, isNullOrUndefined} from "util";
import {AbstractControl} from "@angular/forms";
//import {isArray} from "rxjs/util/isArray";
import {totalmem} from "os";
import {isArray} from 'rxjs/internal-compatibility';

declare let moment: any;
declare let jmespath: any;

export let minDate = new moment("1880-07-05T00:00:00-06:00").toDate();
export let maxDate = new moment().toDate();
export let minYear = 1825;
export let maxYear = parseInt(moment().format("YYYY"));

export function isNullOrEmpty(val: any, type: ValueTypes[], name?: string) {
  let determine = false;
  if (isNullOrUndefined(val)) {
    return true;
  }
  switch (type.reduce((s, v) => {
    return s + v;
  })) {
    case 9:
      /*string - single*/
      determine = isNullOrUndefined(val) || val === "";
      break;
    case 10:
      /*string - pair*/
      determine = (isNullOrUndefined(val[0]) && isNullOrUndefined(val[1])) || (val[0] === "" && val[1] === "");
      break;
    case 12:
      /*string - array*/
      determine = val.length === 0 || (val.length === 1 && isNullOrUndefined(val[0])) || (val.length === 1 && val[0] === "");
      break;
    case 18:
      /*number - pair*/
      determine = (isNullOrUndefined(val[0]) && isNullOrUndefined(val[1])) || (val[0] === 0 && val[1] === 0);
      break;
    case 20:
      /*number - array*/
      determine = val.length === 0 || (val.length === 1 && isNullOrUndefined(val[0])) || (val.length === 1 && val[0] === 0);
      break;
    case 33:
      /*boolean - single*/
      determine = !isBoolean(val[0]);
      break;
    case 65:
      /*date - single*/
      determine = (isNullOrUndefined(val[0]) && (isNullOrUndefined(val[1]) || val[1] === "")) ||
        (isNullOrUndefined(val[1]) && (isNullOrUndefined(val[0]) || val[0] === ""));
      break;
    case 66:
      /*date - pair*/
      let regDate = /^((18|19|20)\d\d)[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/;
      let Morty = {
        date0:val[0] || null,
        date1:val[1] || null,
        isDate0:regDate.test(val[0]),
        isDate1:regDate.test(val[1])
      };
      determine = (
        (Morty.isDate0 === true && Morty.date1 === null) ||
        (Morty.isDate1 === true && Morty.date0 === null) ||
        (Morty.isDate0 === true && Morty.isDate1 === true));
      determine = !determine;
      break;
    case 68:
      /*date - array*/
      determine = (isNullOrUndefined(val[0]) && isNullOrUndefined(val[1])) || (val[0] === "" && val[1] === "");
      break;
    case 129:
      /*object - single*/
      determine = !val.hasOwnProperty("value") || isNullOrUndefined(val.value);
      break;
    case 132:
      /*object - array*/
      determine = val.length === 0 || !val[0].hasOwnProperty("value") || isNullOrUndefined(val[0].value);
      break;

  }
  return determine;
}

export function generateUUID() {
  let d = new Date().getTime();
  let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

export function ByString(o: Array<any>, s: string) {
  /*Special Occasion: double aggregate*/
  s = s.replace(/\[(\w+)\]/g, ".$1");
  /*convert indexes to properties*/
  s = s.replace(/^\./, "");
  /*strip a leading dot*/
  let props = s.split(".");
  for (let i = 0, n = props.length; i < n; ++i) {
    let k = props[i];
    if (k in o) {
      o = o[k];
    } else {
      /*return o;*/
    }
  }
  return o;
}

export function ValidateUrl(control: AbstractControl) {
  if (!control.value.startsWith("https") || !control.value.includes(".io")) {
    return {validUrl:true};
  }
  return null;
}

export function ValidAsArray(control: AbstractControl) {
  if (isArray(control.value) && (control.value.length > 0)) {
    return {validAsArray:true};
  }
  return {validAsArray:false};
}

export function ValidAsNotEmpty(control: AbstractControl) {
  if (!isNullOrUndefined(control.value) && (control.value.length > 0)) {
    return {validAsNotEmpty:true};
  }
  return {validAsNotEmpty:false};
}

export function ValidAsNotNull(control: AbstractControl) {
  if (!isNullOrUndefined(control.value)) {
    return {validAsNotNull:true};
  }
  return {validAsNotNull:false};
}

export function populateYears() {
  let years: Array<string> = [];
  for (let i = 1825; i < maxYear + 1; i++) {
    years.push(i.toString());
  }
  return years;
}

export function padRight(value: string, character: string, totalLength: number): string {
  let _result = "";
  let _padding = "";
  let _length = totalLength <= 0 ? value.length : totalLength;
  for (let i = 0; i < _length; i++) {
    _padding += character;
  }
  _result = (value + _padding).substr(0, _length);
  return _result;
}

export function timer() {
  let timeStart = new Date().getTime();
  return {
    /** <integer>s e.g 2s etc. */
    get seconds() {
      const seconds = Math.ceil((new Date().getTime() - timeStart) / 1000) + "s";
      return seconds;
    },
    /** Milliseconds e.g. 2000ms etc. */
    get ms() {
      const ms = (new Date().getTime() - timeStart);
      return ms;
    }
  };
}

export function makeArray(i: number): Array<number> {
  let x = (i) => {return i ? x(i - 1).concat(i) : []; };

  return x(i);
}

export function flattenMyObj(data) {
  let result = {};

  function recurse(cur, prop) {
    let l: number = 0;
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for (let i = 0, l = cur.length; i < l; i++) {
        recurse(cur[i], prop ? prop + "_" + i : "" + i);
      }
      if (l == 0) {
        result[prop] = [];
      }
    } else {
      let isEmpty = true;
      for (let p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "_" + p : p);
      }
      if (isEmpty) {
        result[prop] = {};
      }
    }
  }

  recurse(data, "");
  return result;
}

export enum SortDirection {
  asc = 1,
  desc = -1
}

export function popFunct(obj) {
  for (let key in obj) {
    // Uncomment below to fix prototype problem.
    // if (!Object.hasOwnProperty.call(obj, key)) continue;
    let result = obj[key];
    // If the property can't be deleted fail with an error.
    if (!delete obj[key]) {
      throw new Error();
    }
    return result;
  }
}

export enum LogLevels {
  log = 1,
  info = 2,
  debug = 4,
  warning = 8,
  error = 16,
  verbose = log | info | debug | warning | error
}

export enum ValueTypes {
  single = 1,
  pair = 2,
  array = 4,
  string = 8,
  number = 16,
  boolean = 32,
  date = 64,
  object = 128,
  currency = 256,
  percent = 512,
  any = single | pair | array | string | number | boolean | date | currency | percent
}

